import {
  ASSETS_LOADING,
  LOAD_ASSETS,
  CREATE_ASSET,
  UPDATE_ASSET,
  DELETE_ASSET,
  OPEN_ASSET,
  ASSETS_IMPORT_STATUS,
} from '../actions/assetsManagement';

const initialState = {
  loadingAssets: false,
  assets: [],
  assetSearchString: '',
  page: 0,
  perPage: 20,
  totalPages: 1,
  selectedAsset: {},
  assetsImportStatus: {},
};

export default ( state = initialState, action ) => {
  switch (action.type) {
    case ASSETS_LOADING:
      return {
        ...state,
        loadingAssets : action.payload,
      };

    case LOAD_ASSETS: {
      const assets =
        action && action.payload && action.payload.data
          ? action.payload.data : [];

      const assetSearchString =
        action && action.payload && action.payload.assetSearchString
          ? action.payload.assetSearchString : initialState.assetSearchString;

      const page =
        action && action.payload && action.payload.page
          ? action.payload.page : initialState.page;
      const perPage =
        action && action.payload && action.payload.per_page
          ? action.payload.per_page : initialState.perPage;
      const totalPages =
        action && action.payload && action.payload.total
          ? ( Math.ceil(action.payload.total / perPage) )
          : initialState.totalPages;

      return {
        ...state,
        assets,
        assetSearchString,
        page,
        perPage,
        totalPages,
      };
    }

    case CREATE_ASSET:
      return {
        ...state,
        assets: [...state.assets, action.payload],
      };

    case UPDATE_ASSET:
      const filteredData = state.assets.filter(asset => asset._id !== action.payload._id);
      return {
        ...state,
        assets: [...filteredData, action.payload],
      };

    case DELETE_ASSET:
      return {
        ...state,
        assets: state.assets.filter(asset => asset._id !== action.payload),
      };

    case OPEN_ASSET:
      return {
        ...state,
        selectedAsset: action.payload,
      };

    case ASSETS_IMPORT_STATUS:
      return {
        ...state,
        assetsImportStatus: action.payload,
      };

    default:
      return state;
  }

};
